import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=aca58698&"
import script from "./AssignmentList.vue?vue&type=script&lang=ts&"
export * from "./AssignmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports